export default "__VITE_PUBLIC_ASSET__a5e9b025__"